import React, { useState } from 'react';
import './Interests.css';

const Interests = () => {
  const interestsList = [
    {
      title: 'Tennis',
      details: 'I used to play tennis competitively, but now I enjoy playing the sport for the social aspect and improving upon my overall fitness.',
    },
    {
      title: 'Golf',
      details: 'I enjoy playing golf to relax, challenge myself mentally and enjoy the outdoors.',
    },
    {
      title: 'Hockey',
      details: 'Watching and playing hockey fuels my team spirit and love for fast paced sports.',
    },
     {
      title: 'Gym',
      details: 'I enjoy going to the gym to improve my fitness and better myself.',
    },
    {
      title: 'Building Personal Projects/Apps',
      details:
        'I regularly build apps to improve upon my coding skills, learn and experiment with new technologies, and solve real problems.',
    },
    {
      title: 'Machine Learning',
      details: 'The fact that it powers so much around us, and combines math, logic, and creativty facinates me.',
    },
    {
      title: 'Artificial Intelligence (AI)',
      details: 'I enjoy researching AI techniques to automate tasks and create smart applications.',
    },
    {
      title: 'Data Analysis',
      details: 'I enjoy analyzing and creating large datasets to recognize valuable insights and trends.',
    },
    {
      title: 'Sports Statistics',
      details: 'I enjoy using sports statistics to see how they have influenced different sporting events.',
    },
    {
      title: 'Baseball',
      details: 'I love following baseball, especially analyzing player performance metrics and team strategies. The combination of statistics, strategy, and the timeless nature of the game really appeals to me. I enjoy watching games, tracking player stats throughout the season, and discussing the nuances of different plays and managerial decisions.',
    },
  ];

  const [selectedIndex, setSelectedIndex] = useState(null);

  return (
      <main className="interests-container" id="interests">
        <h1 className="interests-title">Interests</h1>

        <section className="interests-buttons">
          {interestsList.map(({ title }, idx) => {
            const isSelected = selectedIndex === idx;
            return (
              <button
                key={idx}
                className={`interest-btn ${isSelected ? 'selected' : ''}`}
                onClick={() => setSelectedIndex(idx)}
                aria-pressed={isSelected}
              >
                {title}
              </button>
            );
          })}
        </section>

        {selectedIndex !== null && (
          <section
            className="interest-details-container"
            aria-live="polite"
            aria-atomic="true"
          >
            <h2 className="details-title">{interestsList[selectedIndex].title}</h2>
            <p className="details-text">{interestsList[selectedIndex].details}</p>
          </section>
        )}
      </main>
  );
};

export default Interests;

